export type CookieCategory = "Essential" | "Analytics" | "Marketing";

export interface CookieEntry {
  name: string;
  category: CookieCategory;
  purpose: string;
  duration: string;
}

// Honest as of this writing: ZenFresh does not yet set any real analytics or
// marketing cookies (src/utils/analytics.ts's trackEvent only logs to the
// console in dev and sends nothing anywhere). The one real entry below is
// the consent preference itself. Add real rows here — not before — once GA4
// or any marketing pixel actually goes live; see cookieConsentStore.ts.
export const COOKIES: CookieEntry[] = [
  {
    name: "zenfresh_cookie_consent_v1",
    category: "Essential",
    purpose: "Remembers your cookie preferences so we don't ask again on every visit.",
    duration: "1 year, or until you clear your browser storage",
  },
];
